import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGogDotComComponent } from './simple-icons-gog-dot-com.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGogDotComComponent ],
    exports:      [ SimpleIconsGogDotComComponent ],
    bootstrap:    []
})
export class SimpleIconsGogDotComModule {}
